import React, { useState } from "react";
import { Container } from "./styles";
import Auth from "../../Auth";
import Utils, { sendAppEvent } from "../../Utils";
import Modal from "react-modal";
import useClickedOutside from "../../hooks/useClickedOutside";

Modal.setAppElement("#root");

const PurchasePacks = ({ subscription, close, nextUrl }) => {
  const [fetching, setFetching] = useState(false);
  const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  const wordsOrCredits = subscription.usesLedgers ? "credits" : "AI words";

  const ref = useClickedOutside(close);

  const customStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(55, 55, 55, 0.7)",
    },
    content: {
      top: "20%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      zIndex: "20000",
      width: subscription.packs.length > 3 ? "1000px" : "750px",
      transform: "translate(-50%, 0)",
      borderRadius: "45px",
      border: "0px",
      padding: "0px",
      background: "#f5f2e4",
      boxShadow: "var(--default-drop-shadow)",
    },
  };

  return (
    <Modal
      isOpen={true}
      contentRef={(node) => (ref.current = node)}
      style={customStyles}
    >
      <Container>
        <h1>{`Buy ${subscription.usesLedgers ? "Credits" : "AI Words"}`}</h1>
        <h2>{`These ${wordsOrCredits} never expire`}</h2>

        <div>
          <ul>
            {subscription.packs.map((pack, i) => {
              const displayPrice = "$" + (pack.amount / 100.0).toFixed(0);
              const displayQuota = Utils.numberWithCommas(pack.quota);

              return (
                <li key={i}>
                  <h3>{pack.name}</h3>

                  <div className="container">
                    <div className="img">
                      <img src={`/assets/packs-${i}.png`} />
                    </div>

                    <h4>{displayQuota}</h4>
                    <p>{wordsOrCredits}</p>

                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        if (!fetching) {
                          const packSizeFormatted = Utils.numberWithCommas(pack.quota);

                          sendAppEvent("Pack selected", {
                            pack_id: pack.id,
                            pack_name: pack.name,
                            pack_quota: pack.quota,
                            pack_quota_formatted: packSizeFormatted,
                            pack_amount: pack.amount,
                            pack_price: pack.amount / 100,
                            subscription_id: subscription?.id,
                            uses_credits: subscription?.usesLedgers,
                          });

                          setFetching(true);
                          Auth.fetchWithIdToken("/checkout/createPackSession", {
                            id: pack.id,
                            next_url: nextUrl || window.location.href,
                          }).then(function (result) {
                            stripe.redirectToCheckout({
                              sessionId: result.sessionId,
                            });
                          });
                        }
                      }}
                    >
                      {displayPrice}
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </Container>
    </Modal>
  );
};

export default PurchasePacks;
